import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { PipesModule } from '@fcom/common/pipes';
import { UiTranslateModule } from '@fcom/ui-translate';

import { ButtonModule } from '../buttons';
import { IconsModule } from '../icons/icons.module';
import { LoaderModule } from '../loader';
import { NotificationsModule } from '../notifications';
import { PopoverModule } from '../popover/popover.module';
import { CheckboxInputComponent } from './checkbox-input/checkbox-input.component';
import { ComboBoxComponent } from './combo-box/combo-box.component';
import { AttachmentListComponent } from './file-uploader/attachment-list.component';
import { FileUploaderComponent } from './file-uploader/file-uploader.component';
import { RadioItemGroupComponent, RadioItemGroupContentDirective } from './radio-item-group/radio-item-group.component';
import { SelectInputComponent } from './select-input/select-input.component';
import { TextInputComponent } from './text-input/text-input.component';

@NgModule({
  declarations: [
    AttachmentListComponent,
    FileUploaderComponent,
    RadioItemGroupContentDirective,
    RadioItemGroupComponent,
    TextInputComponent,
    SelectInputComponent,
    ComboBoxComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule.withConfig({
      callSetDisabledState: 'whenDisabledForLegacyCode',
    }),
    UiTranslateModule,
    IconsModule,
    ButtonModule,
    CheckboxInputComponent,
    PipesModule,
    PopoverModule,
    NotificationsModule,
    LoaderModule,
  ],
  exports: [
    AttachmentListComponent,
    FileUploaderComponent,
    CheckboxInputComponent,
    RadioItemGroupContentDirective,
    RadioItemGroupComponent,
    TextInputComponent,
    SelectInputComponent,
    ComboBoxComponent,
  ],
})
export class FcomFormsModule {}
